import React from 'react';
import { Button, Tooltip } from 'antd';
import { ProviderGroup } from '@/DTOS/ProviderGroup/ProviderGroup';
import { EditOutlined} from '@ant-design/icons';

export const ProviderGroupColumn = (
  handleEdit: (record: ProviderGroup) => void
) => [
    
    {
      title: 'Agent Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Denumire',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 200,
      render: (record: boolean) => (record ? 'Activ' : 'Inactiv'),
    },
    {
      title: 'Actiune',
      dataIndex: '',
      key: 'actions',
      render: (record: any) => (
        <Tooltip title='Modifica'>
        <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
        </Tooltip>
      ),
      width: 120,
    },
  ];
